import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cuts = [{
  title: "בריסקט מעושן",
  description: "נתח חזה בקר עסיסי שעבר עישון איטי של 14 שעות בעץ אלון.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/smoked_brisket_cut.png",
  link: "/SmokedMenuPage"
}, {
  title: "אסאדו על העצם",
  description: "צלעות בקר בתיבול הבית, רכות ונימוחות שמתפרקות מהעצם.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/asado_short_ribs.png",
  link: "/SmokedMenuPage"
}, {
  title: "בשר מפורק",
  description: "כתף בקר מעושנת ומפורקת, מוגשת בלחמנייה או כתוספת עשירה.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/pulled_beef_sandwich.png",
  link: "/SmokedMenuPage"
}, {
  title: "פיקאניה מעושנת",
  description: "נתח אחורי משובח עם שכבת שומן פריכה וטעם מעושן עדין.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557505/img/smoked_picanha_slice.png",
  link: "/SmokedMenuPage"
}];
export default function OurEliteCuts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="נתחי-העלית-שלנו" className="dark bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={ref} className={cn("text-center mb-16 transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight text-primary">
            נתחי העלית שלנו
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">גלריית הבשרים המובחרים שלנו כל נתח נבחר בקפידה ועובר תהליך עישון מסורתי לקבלת טעמים בלתי נשכחים</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {cuts.map((cut, i) => <div key={i} data-index={i} className={cn("group relative h-80 md:h-96 rounded-xl overflow-hidden cursor-pointer shadow-lg transition-all duration-700 delay-[100ms]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              {}
              <div className="absolute inset-0 w-full h-full">
                <img src={cut.image} alt={cut.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60 group-hover:opacity-0 transition-opacity duration-300" />
              </div>

              {}
              <div className="absolute inset-0 bg-secondary/90 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out flex flex-col justify-end p-6 md:p-8 text-right">
                <h3 className="text-2xl font-bold text-foreground mb-2 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-100">
                  {cut.title}
                </h3>
                <p className="text-muted-foreground mb-6 text-sm md:text-base transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-150">
                  {cut.description}
                </p>
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-200">
                  <Link to={cut.link} className="inline-flex items-center gap-2 text-primary font-bold hover:text-primary/80 transition-colors text-lg">
                    <span>לפרטים נוספים</span>
                    <ArrowLeft className="w-5 h-5" />
                  </Link>
                </div>
              </div>

              {}
              <div className="absolute bottom-0 right-0 left-0 p-6 text-right transform group-hover:translate-y-full transition-transform duration-300">
                <h3 className="text-2xl font-bold text-white drop-shadow-md">
                  {cut.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}